import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, mergeProps as _mergeProps, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0def9d67")

_pushScopeId("data-v-0def9d67")
const _hoisted_1 = { class: "p-grid p-d-flex p-m-1 p-fluid" }
const _hoisted_2 = { class: "p-grid knScheduler p-jc-between p-flex-column" }
const _hoisted_3 = { class: "p-col-12 p-mb-1 p-d-flex p-ai-center p-jc-between" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode()
const _hoisted_5 = {
  key: 0,
  class: "p-d-flex p-ai-center"
}
const _hoisted_6 = {
  key: 0,
  class: "p-float-label p-col-12 p-mb-1"
}
const _hoisted_7 = {
  for: "startDate",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-float-label p-col-12 p-mb-1" }
const _hoisted_9 = {
  for: "refreshRate",
  class: "kn-material-input-label"
}
const _hoisted_10 = {
  key: 1,
  class: "p-d-flex p-flex-wrap p-col-12 p-mb-1"
}
const _hoisted_11 = {
  key: 0,
  class: "p-d-flex p-flex-wrap"
}
const _hoisted_12 = { class: "p-d-flex p-ai-center p-flex-wrap itemClass" }
const _hoisted_13 = {
  class: "p-mr-2",
  style: {"white-space":"nowrap"}
}
const _hoisted_14 = { class: "p-d-flex p-ai-center" }
const _hoisted_15 = {
  key: 1,
  class: "p-d-flex p-flex-wrap"
}
const _hoisted_16 = { class: "p-ml-2" }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "p-d-flex p-ai-center" }
const _hoisted_19 = { class: "p-d-flex p-ai-center p-flex-wrap itemClass" }
const _hoisted_20 = { class: "p-d-flex p-ai-center p-flex-wrap itemClass" }
const _hoisted_21 = { key: 3 }
const _hoisted_22 = { class: "p-d-flex p-ai-center" }
const _hoisted_23 = { class: "p-d-flex p-ai-center p-flex-wrap itemClass" }
const _hoisted_24 = { class: "p-d-flex p-ai-center p-flex-wrap itemClass" }
const _hoisted_25 = { key: 4 }
const _hoisted_26 = { class: "p-float-label p-col-12" }
const _hoisted_27 = {
  key: 2,
  class: "p-float-label p-col-12 p-mb-1"
}
const _hoisted_28 = {
  for: "endDate",
  class: "kn-material-input-label"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Message = _resolveComponent("Message")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Button = _resolveComponent("Button")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_i18n_t = _resolveComponent("i18n-t")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Card = _resolveComponent("Card")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.showHint)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          severity: "info",
          closable: false
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.monitoring.hint')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      (_ctx.schedulerVisible)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: _ctx.getSchedulerClass
          }, [
            _createVNode(_component_Card, { class: "kn-card full-height" }, {
              content: _withId(() => [
                _createVNode("div", _hoisted_2, [
                  _createVNode("div", _hoisted_3, [
                    _createVNode("div", null, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('knScheduler.enableSchedulation')), 1),
                      _hoisted_4,
                      _createVNode(_component_InputSwitch, {
                        modelValue: _ctx.enableSchedulation,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.enableSchedulation = $event)),
                        onChange: _ctx.toggleSchedulationEnabled
                      }, null, 8, ["modelValue", "onChange"])
                    ]),
                    (_ctx.enableSchedulation)
                      ? (_openBlock(), _createBlock("div", _hoisted_5, [
                          (_ctx.paused)
                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.$t('knScheduler.resumeSchedulation')) + " ", 1),
                                _createVNode(_component_Button, {
                                  icon: "pi pi-play",
                                  class: "p-button-text p-button-rounded p-button-plain",
                                  onClick: _ctx.togglePause
                                }, null, 8, ["onClick"])
                              ], 64))
                            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.$t('knScheduler.pauseSchedulation')) + " ", 1),
                                _createVNode(_component_Button, {
                                  icon: "pi pi-pause",
                                  class: "p-button-text p-button-rounded p-button-plain",
                                  onClick: _ctx.togglePause
                                }, null, 8, ["onClick"])
                              ], 64))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.descriptor.config.startDateEnabled)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, [
                        _createVNode(_component_Calendar, {
                          id: "startDate",
                          modelValue: _ctx.startDate,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.startDate = $event)),
                          showIcon: true,
                          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched')))
                        }, null, 8, ["modelValue"]),
                        _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('kpi.targetDefinition.startDate')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_8, [
                    _createVNode(_component_Dropdown, {
                      id: "selectedRefreshRate",
                      class: "kn-material-input",
                      modelValue: _ctx.selectedRefreshRate,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedRefreshRate = $event)),
                      dataKey: "id",
                      optionLabel: "name",
                      optionValue: "code",
                      options: _ctx.refreshRates,
                      maxLength: "100",
                      onChange: _cache[5] || (_cache[5] = 
                                    () => {
                                        _ctx.resetFormula()
                                        _ctx.$emit('touched')
                                    }
                                ),
                      disabled: _ctx.isDisabled
                    }, null, 8, ["modelValue", "options", "disabled"]),
                    _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t(_ctx.descriptor.refreshRate.placeholder)), 1)
                  ]),
                  (_ctx.selectedRefreshRate)
                    ? (_openBlock(), _createBlock("div", _hoisted_10, [
                        (_ctx.selectedRefreshRate === 'daily')
                          ? (_openBlock(), _createBlock("div", _hoisted_11, [
                              _createVNode("div", _hoisted_12, [
                                _createVNode(_component_RadioButton, {
                                  class: _ctx.descriptor.style.radiobutton,
                                  id: "dayConf1",
                                  name: "dayConf",
                                  value: "everyDay",
                                  modelValue: _ctx.dayConf,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dayConf = $event)),
                                  disabled: _ctx.isDisabled,
                                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('touched')))
                                }, null, 8, ["class", "modelValue", "disabled"]),
                                _createVNode(_component_i18n_t, {
                                  keypath: "knScheduler.everyDay",
                                  tag: "div",
                                  class: "p-d-flex p-ai-center p-mr-2"
                                }, {
                                  day: _withId(() => [
                                    _createVNode(_component_Dropdown, {
                                      id: "type",
                                      class: _ctx.descriptor.style.dropdown,
                                      modelValue: _ctx.selectedDay,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedDay = $event)),
                                      optionLabel: "name",
                                      optionValue: "code",
                                      options: _ctx.getNumberOptions(5),
                                      maxLength: "100",
                                      onChange: _cache[9] || (_cache[9] = 
                                                    () => {
                                                        _ctx.dayConf = 'everyDay'
                                                        _ctx.$emit('touched')
                                                    }
                                                ),
                                      disabled: _ctx.isDisabled
                                    }, null, 8, ["class", "modelValue", "options", "disabled"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('knScheduler.startingIn')), 1),
                                _createVNode(_component_Dropdown, {
                                  id: "type",
                                  class: _ctx.descriptor.style.dropdown,
                                  modelValue: _ctx.selectedDayExtended,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedDayExtended = $event)),
                                  dataKey: "id",
                                  optionLabel: "name",
                                  optionValue: "id",
                                  options: _ctx.days,
                                  maxLength: "100",
                                  onChange: _cache[11] || (_cache[11] = 
                                            () => {
                                                _ctx.dayConf = 'everyDay'
                                                _ctx.$emit('touched')
                                            }
                                        ),
                                  disabled: _ctx.isDisabled
                                }, null, 8, ["class", "modelValue", "options", "disabled"])
                              ]),
                              _createVNode("div", _hoisted_14, [
                                _createVNode(_component_RadioButton, {
                                  class: _ctx.descriptor.style.radiobutton,
                                  id: "dayConf2",
                                  name: "dayConf",
                                  value: "everyNotWorkingDays",
                                  modelValue: _ctx.dayConf,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.dayConf = $event)),
                                  disabled: _ctx.isDisabled,
                                  onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('touched')))
                                }, null, 8, ["class", "modelValue", "disabled"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('knScheduler.everyNotWorkingDays')), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.selectedRefreshRate === 'weekly')
                          ? (_openBlock(), _createBlock("div", _hoisted_15, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.descriptor.days, (day, index) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "p-d-flex field-checkbox p-mb-1 p-mr-2 dayCheckbox",
                                  key: index
                                }, [
                                  _createVNode(_component_Checkbox, {
                                    id: day - `${index}`,
                                    name: day.name,
                                    value: day.code,
                                    modelValue: _ctx.selectedWeekdays[day.id],
                                    "onUpdate:modelValue": ($event: any) => (_ctx.selectedWeekdays[day.id] = $event),
                                    onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('touched')))
                                  }, null, 8, ["id", "name", "value", "modelValue", "onUpdate:modelValue"]),
                                  _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t(day.name)), 1)
                                ]))
                              }), 128))
                            ]))
                          : (_ctx.selectedRefreshRate === 'monthly')
                            ? (_openBlock(), _createBlock("div", _hoisted_17, [
                                _createVNode(_component_i18n_t, {
                                  keypath: "knScheduler.everyMonth",
                                  tag: "div",
                                  class: "p-d-flex p-ai-center p-mr-2"
                                }, {
                                  month: _withId(() => [
                                    _createVNode(_component_Dropdown, {
                                      id: "selectedMonth",
                                      class: _ctx.descriptor.style.dropdown,
                                      modelValue: _ctx.selectedMonth,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.selectedMonth = $event)),
                                      optionLabel: "name",
                                      optionValue: "id",
                                      options: _ctx.getNumberOptions(5),
                                      maxLength: "100",
                                      disabled: _ctx.isDisabled
                                    }, null, 8, ["class", "modelValue", "options", "disabled"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode("div", _hoisted_18, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('knScheduler.startingIn')) + " ", 1),
                                  _createVNode(_component_Dropdown, {
                                    id: "selectedMonthExtended",
                                    class: _ctx.descriptor.style.dropdown,
                                    modelValue: _ctx.selectedMonthExtended,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.selectedMonthExtended = $event)),
                                    dataKey: "id",
                                    optionLabel: "name",
                                    optionValue: "id",
                                    options: _ctx.months,
                                    maxLength: "100",
                                    disabled: _ctx.isDisabled
                                  }, null, 8, ["class", "modelValue", "options", "disabled"])
                                ]),
                                _createVNode("div", _hoisted_19, [
                                  _createVNode(_component_RadioButton, {
                                    class: _ctx.descriptor.style.radiobutton,
                                    id: "monthConf1",
                                    name: "monthConf",
                                    modelValue: _ctx.monthConf,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.monthConf = $event)),
                                    value: "theDay",
                                    disabled: _ctx.isDisabled,
                                    onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('touched')))
                                  }, null, 8, ["class", "modelValue", "disabled"]),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('knScheduler.theDay')) + " ", 1),
                                  _createVNode(_component_Dropdown, {
                                    id: "selectedDayNumber",
                                    class: _ctx.descriptor.style.dropdown,
                                    modelValue: _ctx.selectedDayNumber,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.selectedDayNumber = $event)),
                                    dataKey: "id",
                                    optionLabel: "name",
                                    optionValue: "code",
                                    options: _ctx.getNumberOptions(31),
                                    maxLength: "100",
                                    onChange: _cache[20] || (_cache[20] = 
                                            () => {
                                                _ctx.monthConf = 'theDay'
                                            }
                                        ),
                                    disabled: _ctx.isDisabled
                                  }, null, 8, ["class", "modelValue", "options", "disabled"])
                                ]),
                                _createVNode("div", _hoisted_20, [
                                  _createVNode(_component_RadioButton, {
                                    class: _ctx.descriptor.style.radiobutton,
                                    id: "monthConf2",
                                    name: "monthConf",
                                    modelValue: _ctx.monthConf,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.monthConf = $event)),
                                    value: "theOrdinalDay",
                                    disabled: _ctx.isDisabled
                                  }, null, 8, ["class", "modelValue", "disabled"]),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('knScheduler.the')) + " ", 1),
                                  _createVNode(_component_Dropdown, {
                                    id: "selectedDayOrdinal",
                                    class: _ctx.descriptor.style.dropdown,
                                    modelValue: _ctx.selectedDayOrdinal,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.selectedDayOrdinal = $event)),
                                    dataKey: "id",
                                    optionLabel: "name",
                                    optionValue: "id",
                                    options: _ctx.ordinal,
                                    maxLength: "100",
                                    onChange: _cache[23] || (_cache[23] = 
                                            () => {
                                                _ctx.monthConf = 'theOrdinalDay'
                                            }
                                        ),
                                    disabled: _ctx.isDisabled
                                  }, null, 8, ["class", "modelValue", "options", "disabled"]),
                                  _createVNode(_component_Dropdown, {
                                    id: "selectedDayExtended",
                                    class: _ctx.descriptor.style.dropdown,
                                    modelValue: _ctx.selectedDayExtended,
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.selectedDayExtended = $event)),
                                    dataKey: "id",
                                    optionLabel: "name",
                                    optionValue: "id",
                                    options: _ctx.days,
                                    maxLength: "100",
                                    onChange: _cache[25] || (_cache[25] = 
                                            () => {
                                                _ctx.monthConf = 'theOrdinalDay'
                                            }
                                        ),
                                    disabled: _ctx.isDisabled
                                  }, null, 8, ["class", "modelValue", "options", "disabled"])
                                ])
                              ]))
                            : (_ctx.selectedRefreshRate === 'yearly')
                              ? (_openBlock(), _createBlock("div", _hoisted_21, [
                                  _createVNode(_component_i18n_t, {
                                    keypath: "knScheduler.everyYear",
                                    tag: "div",
                                    class: "p-d-flex p-ai-center p-mr-2"
                                  }, {
                                    year: _withId(() => [
                                      _createVNode(_component_Dropdown, {
                                        id: "selectedYear",
                                        class: _ctx.descriptor.style.dropdown,
                                        modelValue: _ctx.selectedYear,
                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.selectedYear = $event)),
                                        dataKey: "id",
                                        optionLabel: "name",
                                        optionValue: "code",
                                        options: _ctx.getNumberOptions(5),
                                        maxLength: "100",
                                        disabled: _ctx.isDisabled
                                      }, null, 8, ["class", "modelValue", "options", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode("div", _hoisted_22, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('knScheduler.in')) + " ", 1),
                                    _createVNode(_component_Dropdown, {
                                      id: "selectedMonth",
                                      class: _ctx.descriptor.style.dropdown,
                                      modelValue: _ctx.selectedMonth,
                                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.selectedMonth = $event)),
                                      dataKey: "id",
                                      optionLabel: "name",
                                      optionValue: "code",
                                      options: _ctx.months,
                                      maxLength: "100",
                                      disabled: _ctx.isDisabled
                                    }, null, 8, ["class", "modelValue", "options", "disabled"])
                                  ]),
                                  _createVNode("div", _hoisted_23, [
                                    _createVNode(_component_RadioButton, {
                                      class: _ctx.descriptor.style.radiobutton,
                                      id: "monthConf1",
                                      name: "yearConf",
                                      modelValue: _ctx.yearConf,
                                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.yearConf = $event)),
                                      value: "theDay",
                                      disabled: _ctx.isDisabled
                                    }, null, 8, ["class", "modelValue", "disabled"]),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('knScheduler.theDay')) + " ", 1),
                                    _createVNode(_component_Dropdown, {
                                      id: "type",
                                      class: _ctx.descriptor.style.dropdown,
                                      modelValue: _ctx.selectedDayNumber,
                                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.selectedDayNumber = $event)),
                                      dataKey: "id",
                                      optionLabel: "name",
                                      optionValue: "code",
                                      options: _ctx.getNumberOptions(31),
                                      maxLength: "100",
                                      onChange: _cache[30] || (_cache[30] = 
                                            () => {
                                                _ctx.yearConf = 'theDay'
                                            }
                                        ),
                                      disabled: _ctx.isDisabled
                                    }, null, 8, ["class", "modelValue", "options", "disabled"])
                                  ]),
                                  _createVNode("div", _hoisted_24, [
                                    _createVNode(_component_RadioButton, {
                                      class: _ctx.descriptor.style.radiobutton,
                                      id: "monthConf2",
                                      name: "yearConf",
                                      modelValue: _ctx.yearConf,
                                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.yearConf = $event)),
                                      value: "theOrdinalDay",
                                      disabled: _ctx.isDisabled
                                    }, null, 8, ["class", "modelValue", "disabled"]),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('knScheduler.the')) + " ", 1),
                                    _createVNode(_component_Dropdown, {
                                      id: "selectedDayOrdinal",
                                      class: _ctx.descriptor.style.dropdown,
                                      modelValue: _ctx.selectedDayOrdinal,
                                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.selectedDayOrdinal = $event)),
                                      dataKey: "id",
                                      optionLabel: "name",
                                      optionValue: "id",
                                      options: _ctx.ordinal,
                                      maxLength: "100",
                                      onChange: _cache[33] || (_cache[33] = 
                                            () => {
                                                _ctx.yearConf = 'theOrdinalDay'
                                            }
                                        ),
                                      disabled: _ctx.isDisabled
                                    }, null, 8, ["class", "modelValue", "options", "disabled"]),
                                    _createVNode(_component_Dropdown, {
                                      id: "selectedDayExtended",
                                      class: _ctx.descriptor.style.dropdown,
                                      modelValue: _ctx.selectedDayExtended,
                                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.selectedDayExtended = $event)),
                                      dataKey: "id",
                                      optionLabel: "name",
                                      optionValue: "id",
                                      options: _ctx.days,
                                      maxLength: "100",
                                      onChange: _cache[35] || (_cache[35] = 
                                            () => {
                                                _ctx.yearConf = 'theOrdinalDay'
                                            }
                                        ),
                                      disabled: _ctx.isDisabled
                                    }, null, 8, ["class", "modelValue", "options", "disabled"])
                                  ])
                                ]))
                              : (_ctx.selectedRefreshRate === 'custom')
                                ? (_openBlock(), _createBlock("div", _hoisted_25, [
                                    _createVNode("span", _hoisted_26, [
                                      _createVNode(_component_InputText, _mergeProps({
                                        id: _ctx.name,
                                        type: "text",
                                        modelValue: _ctx.localCronExpression,
                                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.localCronExpression = $event))
                                      }, _ctx.$attrs, {
                                        class: [_ctx.cssClass ? _ctx.cssClass + ' kn-truncated' : 'kn-material-input kn-truncated', _ctx.required && !_ctx.modelValue ? 'p-invalid' : ''],
                                        onChange: _cache[37] || (_cache[37] = ($event: any) => (_ctx.$emit('update:currentCronExpression', _ctx.localCronExpression))),
                                        disabled: _ctx.isDisabled
                                      }), null, 16, ["id", "modelValue", "class", "disabled"])
                                    ]),
                                    _createVNode("small", {
                                      id: "custom-cron-hint",
                                      innerHTML: _ctx.$t('knScheduler.customCronHint')
                                    }, null, 8, ["innerHTML"])
                                  ]))
                                : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.descriptor.config.endDateEnabled)
                    ? (_openBlock(), _createBlock("div", _hoisted_27, [
                        _createVNode(_component_Calendar, {
                          id: "icon",
                          modelValue: _ctx.endDate,
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.endDate = $event)),
                          showIcon: true
                        }, null, 8, ["modelValue"]),
                        _createVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('kpi.targetDefinition.endDate')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.readOnly)
                    ? (_openBlock(), _createBlock(_component_Message, {
                        key: 3,
                        class: ['p-col-12 messageClass', _ctx.readOnly ? 'p-message-disabled' : ''],
                        severity: 'info'
                      }, {
                        default: _withId(() => [
                          (_ctx.paused)
                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.$t('knScheduler.schedulationPaused')), 1)
                              ], 64))
                            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.getCronstrueFormula), 1)
                              ], 64))
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.logsVisible)
        ? (_openBlock(), _createBlock("div", {
            key: 1,
            class: _ctx.getLogsTableClass
          }, [
            _createVNode(_component_Card, { class: "kn-card full-height--with-toolbar" }, {
              header: _withId(() => [
                _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
                  start: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.monitoring.executionLogs')), 1)
                  ]),
                  _: 1
                })
              ]),
              content: _withId(() => [
                _createVNode(_component_DataTable, {
                  value: _ctx.logs,
                  filters: _ctx.filters,
                  "onUpdate:filters": _cache[39] || (_cache[39] = ($event: any) => (_ctx.filters = $event)),
                  class: "p-datatable-sm kn-table",
                  columnResizeMode: "fit | expand",
                  dataKey: "id",
                  paginator: true,
                  rows: 10,
                  paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                  responsiveLayout: "stack",
                  breakpoint: "960px",
                  currentPageReportTemplate: _ctx.$t('common.table.footer.paginated', { first: '{first}', last: '{last}', totalRecords: '{totalRecords}' }),
                  globalFilterFields: _ctx.descriptor.globalFilterFields,
                  loading: _ctx.loadingLogs
                }, {
                  empty: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
                  ]),
                  loading: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
                  ]),
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.descriptor.columns, (col) => {
                      return (_openBlock(), _createBlock(_component_Column, {
                        class: "kn-truncated",
                        field: col.field,
                        header: col.field !== 'errorFile' ? _ctx.$t(col.header) : '',
                        key: col.field,
                        sortable: col.field !== 'errorFile',
                        selectionMode: col.field == 'selectionMode' ? 'multiple' : '',
                        exportable: col.field == 'selectionMode' ? false : ''
                      }, {
                        body: _withId((slotProps) => [
                          (col.field === 'start' || col.field === 'stop')
                            ? (_openBlock(), _createBlock("span", _hoisted_29, _toDisplayString(_ctx.getFormattedDate(slotProps.data[col.field])), 1))
                            : (_openBlock(), _createBlock("span", _hoisted_30, _toDisplayString(slotProps.data[col.field]), 1))
                        ]),
                        _: 2
                      }, 1032, ["field", "header", "sortable", "selectionMode", "exportable"]))
                    }), 128)),
                    _createVNode(_component_Column, {
                      class: "kn-truncated",
                      field: "errorFile",
                      header: '',
                      sortable: false,
                      selectionMode: false,
                      exportable: false
                    }, {
                      body: _withId((slotProps) => [
                        _createVNode("span", null, [
                          (slotProps.data['status'] === 'KO')
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                icon: "pi pi-download",
                                class: "p-button-link",
                                onClick: ($event: any) => (_ctx.downloadLog(slotProps.data))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "filters", "currentPageReportTemplate", "globalFilterFields", "loading"])
              ]),
              _: 1
            })
          ], 2))
        : _createCommentVNode("", true)
    ])
  ], 64))
})